webpackJsonp([40757032301952],{

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _sidebar = __webpack_require__(18);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _infobox = __webpack_require__(23);
	
	var _infobox2 = _interopRequireDefault(_infobox);
	
	var _roentgen = __webpack_require__(463);
	
	var _roentgen2 = _interopRequireDefault(_roentgen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoentgenPage = function RoentgenPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'Digitales R\xF6ntgen', image: _roentgen2.default }),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom split' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-custom' },
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen zu Hause:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die Untersuchungsregion muss frei von Kleidung und Schmuck sein.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Bringen Sie Ihre ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Vorbefunde'
	              ),
	              ' mit (OP-Berichte, R\xF6ntgenbilder etc.).'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen in der Ordination:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'F\xFCllen Sie in der Ordination das ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Anamneseblatt'
	              ),
	              ' aus.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Spezielle R\xF6ntgenuntersuchungen erfolgen ausschlie\xDFlich nach ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Terminvereinbarung'
	              ),
	              ':',
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Schluckaktr\xF6ntgen'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Magenr\xF6ntgen'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Irrigoskopie'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'IVP'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Befundsbesprechung:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Befundbesprechung'
	              ),
	              ' erfolgt beim \xFCberweisenden Arzt/\xC4rztin.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'aside',
	        { className: 'sidebar' },
	        _react2.default.createElement(_sidebar2.default, null),
	        _react2.default.createElement(_infobox2.default, { name: 'roentgen' })
	      )
	    )
	  );
	};
	
	exports.default = RoentgenPage;
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roentgen.aca07306.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-roentgen-js-853f1094ca4242509f1b.js